import { render, staticRenderFns } from "./EditSettlementKasbon.vue?vue&type=template&id=6cad05f4"
import script from "./EditSettlementKasbon.vue?vue&type=script&lang=js"
export * from "./EditSettlementKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports